import React, { useState } from "react";
import "../styles/Portfolio.css";

const Portfolio = () => {
  const [selectedClient, setSelectedClient] = useState(null);
  const [activeTab, setActiveTab] = useState("websites");

  const projects = {
    apps: [
      {
        id: 1,
        name: "Makkal Sinthanai Peravai",
        description: "",
        website:
          "https://play.google.com/store/apps/details?id=com.sinthanai.peravai",
        image: "/images/mspphoneport/1.png"
      },
      {
        id: 2,
        name: "M Track",
        description: "",
        website: "",
        image: "/images/Attendport/1.png"
      }
    ],
    websites: [
      {
        id: 3,
        name: "Makkal Sinthanai Peravai",
        description: "",
        website: "https://www.makkalsinthanaiperavai.com/",
        image: "/images/mspport/1.png"
      },
      {
        id: 4,
        name: "Erode Book Festival",
        description: "",
        website: "https://www.erodebookfestival.in/",
        image: "/images/ebfport/1.png"
      },
      {
        id: 6,
        name: "T Stalin Gunasekaran",
        description: "",
        website: "https://tstalingunasekaran.in/",
        image: "/images/tsgport/1.png"
      },
      {
        id: 5,
        name: "SEO Ways",
        description: "",
        website: "https://seoways.com/",
        image: "/images/seoport/1.png"
      },
      {
        id: 7,
        name: "Dr.Dhanraj",
        description: "",
        website: "https://drdhanraj.vercel.app/",
        image: "/images/dharaj/1.png"
      }
    ],
    digitalMarketing: [
      {
        id: 9,
        name: "Thariga Products",
        description: "",
        website: "",
        image: "/images/krport/Tha.png"
      },
      {
        id: 10,
        name: "Fly Sports",
        description: "",
        website: "",
        image: ""
      },
      {
        id: 8,
        name: "KR Power",
        description: "",
        website: "",
        image: "/images/krport/1.png"
      }
    ]
  };

  const openFullscreen = (client) => {
    setSelectedClient(client);
  };

  const closeFullscreen = () => {
    setSelectedClient(null);
  };

  return (
    <div className="portfolio-container">
      <h1 className="portfolio-title">Portfolio</h1>

      <div className="portfolio-tabs">
        <button
          className={`tab-button ${activeTab === "websites" ? "active" : ""}`}
          onClick={() => setActiveTab("websites")}
        >
          Websites
        </button>
        <button
          className={`tab-button ${activeTab === "apps" ? "active" : ""}`}
          onClick={() => setActiveTab("apps")}
        >
          Mobile Apps
        </button>
        <button
          className={`tab-button ${
            activeTab === "digitalMarketing" ? "active" : ""
          }`}
          onClick={() => setActiveTab("digitalMarketing")}
        >
          Digital Marketing
        </button>
      </div>

      <div className="clients-grid">
        {projects[activeTab].map((client) => (
          <div key={client.id} className="client-card">
            <div className="client-header">
              <h2 className="client-name">{client.name}</h2>
              <p className="client-description">{client.description}</p>
              {client.website && (
                <a
                  href={client.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="website-link"
                >
                  Visit Website
                </a>
              )}
            </div>

            <div className="client-image-container">
              <div
                className="image-containerport"
                onClick={() => openFullscreen(client)}
              >
                <img
                  src={client.image}
                  alt={`${client.name} screenshot`}
                  className="portfolio-image"
                />
                <div className="image-overlay">
                  <span className="zoom-icon">+</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Fullscreen Popup */}
      {selectedClient && (
        <div className="fullscreen-popup">
          <button className="close-btn" onClick={closeFullscreen}>
            ×
          </button>

          <div className="fullscreen-content">
            <img
              src={selectedClient.image}
              alt={`${selectedClient.name} fullscreen view`}
              className="fullscreen-image"
            />
            <div className="image-info">
              <h3>{selectedClient.name}</h3>
              {selectedClient.website && (
                <a
                  href={selectedClient.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="website-link-popup"
                >
                  Visit {selectedClient.name}'s Website
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Portfolio;
